import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            filter: '',
            onlyActives: true,
            openAddOrder: false,
            drivers: [],
            types: [],
            // pagination: {
            //     page: 1,
            //     limit: 100,
            //     totalCount: 0
            // }
        }
    },
    computed: {
        filteredUsers() {
            return this.drivers.filter(item => {
                return item.username.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    item.firstName.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    item.lastName.toLowerCase().indexOf(this.filter.toLowerCase()) > -1;

            })
        }
    },
    methods: {
        getDrivers: getDrivers,
        deleteDriver: deleteDriver,
        keymonitor: keymonitor,
        clickSearch: clickSearch,
        deactivateDriver: deactivateDriver,
        resetLozinke: resetLozinke,
        onClickUser: onClickUser,
        openAddUserModal: openAddUserModal,
        compareActive(a, b) {
            let aActive = a.active;
            let bActive = b.active;
            if (aActive)
                return -1;
            if (bActive)
                return 1;
            return 0;
        },

        compareOrders(a, b) {
            let aActive = a.activeOrders;
            let bActive = b.activeOrders;
            if (aActive > bActive)
                return -1;
            if (aActive < bActive)
                return 1;
            return 0;
        },

    },
    created(){
        let _self = this;
        this.$topnavbar.$on('closeAddDispatcher', () => {
            _self.openAddOrder = false;
        });
        this.$topnavbar.$on('successAddDispatcher', () => {
            _self.openAddOrder = false;
            swal('Uspešno', 'Uspešno dodat dispečer', 'success')
            _self.getDrivers();
        });

    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN') {
            this.$router.push('/login');
            return;
        }
        this.getDrivers()
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                // this.pagination.page = 1;
                // this.getDrivers();
            }
        },
        'onlyActives': function (newVal) {
            this.getDrivers();
        }
    }
}

function deactivateDriver(driver) {
    var _self = this;
    AdminApiService.deactivateDriver(driver.id, false)
        .then((response) => {
            _self.getDrivers();
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function openAddUserModal() {
    this.openAddOrder = true;
}

function clickSearch() {
    // this.pagination.page = 1;
    // this.getDrivers()
}

function getDrivers() {
    var _self = this;
    AdminApiService.getDispatchers()
        .then((response) => {
            _self.drivers = response.data;
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


function keymonitor(event) {
    if (event.key === 'Enter') {
        this.getDrivers();
    }
}



function onClickUser(user) {
    swal({
        title: ''+user.name + ' '+ user.surname,
        html : '<html><div class="foo">' +
            '<br><div><b>Korisničko ime:</b>&ensp;'+ user.username+'</div><br>'+
            '<div><b>Email:</b>&ensp;'+ user.email+'</div><br>'+
            '<div><b>Telefon:</b>&ensp;'+ user.phone+'</div><br>'+
            '<div><b>Preostalo treninga:</b>&ensp;'+ user.restOfTraining+'</div><br>'+

            '</div></html>',
        text: "",
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Zatvori',
        customClass: 'swal2-warning'
    }).then(function () {

    });
}

function resetLozinke(driver) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da restartujete lozinku za dispečera " + driver.firstName + " "+ driver.lastName +"? Loznika će biti 12345678",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        let newModel = {
          username: driver.username,
          firstName: driver.firstName,
          lastName: driver.lastName,
          password: '12345678'
        };
        AdminApiService.updateDispatcher(newModel, driver.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste restartovali lozinku za ' + driver.firstName + ' ' + driver.lastName, 'success')
                _self.getDrivers();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });

}

function deleteDriver(driver) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrisete dispečera " + driver.firstName + " "+ driver.lastName +"?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        AdminApiService.deleteDispatcher(driver.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste obrisali vozača', 'success')
                _self.getDrivers();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });

}




// WEBPACK FOOTER //
// ./src/components/Dispatchers/Dispatchers.js